import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex'
import store from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './request/plugins'
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
        if (localStorage.getItem('authNamelist') == undefined) {
            var arrays = ['全局']
            localStorage.setItem('authNamelist', JSON.stringify(arrays))
        }
        var array = JSON.parse(localStorage.getItem('authNamelist'))
        if (!array.includes(to.meta.name)) {
            // 去没有权限的页面
            next('/error')
        } else {
            // 正常走
            next()
        }
    })
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js